import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, LazyImage, Text } from "@miro-site/core";
import React, { useEffect, useRef } from "react";
import { Transition } from "react-transition-group";
import { useTheme } from "styled-components";
import useFullscreenModal from "../../../hooks/useFullscreenModal";
import TransparentButton from "../../button/TransparentButton";
import Popup from "../../popup/Popup";
import { CardTags } from "./CardTags";
var transitionStyles = {
    entering: {
        opacity: 1,
        visibility: "visible"
    },
    entered: {
        opacity: 1,
        visibility: "visible"
    },
    exiting: {
        opacity: 0,
        visibility: "visible"
    },
    exited: {
        opacity: 0,
        visibility: "hidden"
    }
};
var defaultStyle = {
    transition: "opacity 250ms ease-in-out, visibility 250ms ease-in-out",
    opacity: 0,
    visibility: "hidden",
    zIndex: 100
};
var CardDescription = function(param) {
    var _isShown = param.isShown, isShown = _isShown === void 0 ? false : _isShown, onClose = param.onClose, templateActions = param.templateActions, isFullscreen = param.isFullscreen, metadataId = param.metadataId, templatePagePath = param.templatePagePath, previewButton = param.previewButton, actionButtonProps = param.actionButtonProps, thumbnail = param.thumbnail, title = param.title, description = param.description, popupStyles = param.popupStyles, headingStyles = param.headingStyles, descriptionStyles = param.descriptionStyles, tags = param.tags;
    if (isFullscreen) useFullscreenModal(isShown);
    var defaultPreviewButton = /*#__PURE__*/ _jsx(TransparentButton, {
        $size: "medium",
        href: templatePagePath,
        children: templateActions.PREVIEW
    });
    var popupRef = useRef(null);
    var handleOutsideClick = function(e) {
        var clickOutsideNav = popupRef.current && !popupRef.current.contains(e.target);
        if (clickOutsideNav && onClose) {
            onClose();
        }
    };
    useEffect(function() {
        if (!isShown) {
            return;
        }
        document.addEventListener("click", handleOutsideClick, true);
        return function() {
            document.removeEventListener("click", handleOutsideClick, true);
        };
    }, [
        isShown
    ]);
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(Transition, {
        in: isShown,
        timeout: 250,
        children: function(state) {
            return /*#__PURE__*/ _jsx(Popup, {
                ref: popupRef,
                "data-track-place": "card-description",
                onCloseClick: onClose,
                $styles: _object_spread({}, defaultStyle, popupStyles, transitionStyles[state]),
                onMouseLeave: function(e) {
                    return onClose && onClose();
                },
                children: /*#__PURE__*/ _jsxs(Box, {
                    children: [
                        isFullscreen && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                thumbnail && /*#__PURE__*/ _jsx(Box, {
                                    $mb: [
                                        20,
                                        null,
                                        null,
                                        null
                                    ],
                                    $styles: {
                                        position: "relative",
                                        overflow: "hidden",
                                        height: 0,
                                        paddingTop: [
                                            "64.307%",
                                            null,
                                            null,
                                            null
                                        ]
                                    },
                                    children: /*#__PURE__*/ _jsx(LazyImage, _object_spread_props(_object_spread({}, thumbnail), {
                                        detectIntersection: false
                                    }))
                                }),
                                /*#__PURE__*/ _jsxs(Box, {
                                    $mb: [
                                        28,
                                        null,
                                        null,
                                        null
                                    ],
                                    $styles: {
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "space-between",
                                        flexFlow: "row wrap",
                                        height: "100%"
                                    },
                                    children: [
                                        actionButtonProps ? /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                                            "data-track-id": "use-template",
                                            "data-template-id": metadataId,
                                            $mr: [
                                                14,
                                                null
                                            ],
                                            $mb: [
                                                12,
                                                null
                                            ],
                                            $buttonType: "primary",
                                            $size: "medium",
                                            onClick: actionButtonProps.onClick
                                        }, actionButtonProps), {
                                            children: actionButtonProps.children || templateActions.USE_TEMPLATE
                                        })) : null,
                                        previewButton ? previewButton(defaultPreviewButton) : defaultPreviewButton
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            as: "h4",
                            $color: "primaryIndigo",
                            $pr: isFullscreen ? 0 : 48,
                            $mb: [
                                24,
                                12,
                                12,
                                12
                            ],
                            $styles: _object_spread({
                                fontWeight: 700,
                                fontSize: [
                                    24,
                                    16,
                                    16,
                                    16
                                ],
                                lineHeight: [
                                    32,
                                    24,
                                    24,
                                    24
                                ]
                            }, headingStyles),
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(CardTags, {
                            descriptionStyles: descriptionStyles,
                            headingStyles: headingStyles,
                            tags: tags
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            $variant: [
                                "p1",
                                "p2",
                                "p2",
                                "p2"
                            ],
                            $styles: _object_spread({
                                color: theme.templates.colors.secondary60
                            }, descriptionStyles),
                            children: description
                        })
                    ]
                })
            });
        }
    });
};
export default CardDescription;
